module.exports = __webpack_public_path__ + "img/img-archive05.f4ec9b10.png";